import styled from 'styled-components'
import { rem } from 'polished'
import { setSvgIconSize } from 'LuxKit/SvgIcon'
import type SvgIcon from 'LuxKit/SvgIcon'
import SolidBedIcon from 'LuxKit/Icons/solid/SolidBedIcon'
import SolidCompassIcon from 'LuxKit/Icons/solid/SolidCompassIcon'
import SolidShipIcon from 'LuxKit/Icons/solid/SolidShipIcon'
import SolidShieldCheckIcon from 'LuxKit/Icons/solid/SolidShieldCheckIcon'
import SolidPlaneDepartureIcon from 'LuxKit/Icons/solid/SolidPlaneDepartureIcon'
import SolidStarIcon from 'LuxKit/Icons/solid/SolidStarIcon'
import LineHotAirBalloonIcon from 'LuxKit/Icons/line/LineHotAirBalloonIcon'
import LineCarIcon from 'LuxKit/Icons/line/LineCarIcon'

const ITEM_TYPE_ICON_MAP: Record<string, typeof SvgIcon> = {
  accommodation: SolidBedIcon,
  hotel: SolidBedIcon,
  bedbank: SolidBedIcon,
  tour: SolidCompassIcon,
  tour_v2: SolidCompassIcon,
  tour_optional_experience: LineHotAirBalloonIcon,
  tour_experience: LineHotAirBalloonIcon,
  cruise: SolidShipIcon,
  experience: LineHotAirBalloonIcon,
  flight: SolidPlaneDepartureIcon,
  insurance: SolidShieldCheckIcon,
  booking_protection: SolidShieldCheckIcon,
  car_hire: LineCarIcon,
}

export function getItemTypeIcon(itemType: string): typeof SvgIcon {
  return ITEM_TYPE_ICON_MAP[itemType] ?? SolidStarIcon
}

export const ActivityIcon = styled.div`
  height: ${rem(32)};
  width: ${rem(32)};
  ${setSvgIconSize(16)};
  border-radius: ${props => props.theme.borderRadius.round};
  background-color: ${props => props.theme.palette.neutral.surface.lightBackground};
  display: grid;
  place-items: center;
  flex-shrink: 0;
  color: ${props => props.theme.palette.neutral.surface.lightForegroundAlt};
`
